window.showHideSearchContents = function showHideSearchContents() {

    var $searcWrap = $('#content .searchWrap'),
        ajaxURL,
        speed = 0,
        only_scroll_to = false,
        search_trigger = $('.js_triggerSearch'),
        page_id = search_trigger.data('page-id'),
        scroll_element = '',
        siteName = $('body').attr('data-site');

    if ($.browser.safari) {
        scroll_element = $('body');
    } else {
        scroll_element = $('html');
    }

    if ($('.mobileNavBlock').hasClass('fixed')) {
        speed = 800;

        if ($searcWrap.hasClass('formOpen')) {
            only_scroll_to = true;
        }
    }

    // scroll to the top then show the form
    scroll_element.stop(true, false).animate({
        scrollTop: 0
    }, speed , function () {

        if ($searcWrap.length > 0) {

            if (only_scroll_to === false) {

                $searcWrap.toggleClass('formOpen');

                if ($searcWrap.hasClass('formOpen')) {
                    if ($('.js_offersMenuMobile').is(':visible')) {
                        $('.js_offersMenuMobile').slideUp(function () {
                            $('.js_mobileOffersTrigger').removeClass('active');
                            $searcWrap.stop(true, true).slideDown();
                            $('.js_triggerSearch').addClass('active');
                        });
                    } else {
                        $('.flyoutWrap').slideUp(function () {
                            $('.flyout').removeClass('alive');
                            $('.tabsNav ul li a').removeClass('active');
                            $searcWrap.stop(true, true).slideDown();
                            $('.js_triggerSearch').addClass('active');
                        });
                    }
                } else {
                    $('.js_triggerSearch').removeClass('active');
                    $searcWrap.stop(true, true).slideUp();
                    $('.flyoutWrap').removeClass('alive');
                    $('.js_mobileOffersTrigger').removeClass('active');
                }

            }
        } else {
            // if the form is not on the page then load it in and show it
            ajaxURL =  '/sites/' + siteName + '/templates/ajax/load-search-form.php';

            search_trigger.addClass('loading');

            var search_js_loaded = false;

            $.ajax({
                type: 'post',
                url: ajaxURL,
                data: {
                    ajax: true,
                    page_id: page_id
                },
                success: function(response) {
                    if (search_js_loaded !== true) {
                        // load js needed for search on franchise subpages
                        $.getScript('/sites/petervardy/js/site_scripts/mtc_vue_slim_search.js');
                    }

                    search_js_loaded = true;

                    $('#content').prepend(response);

                    $('#content').find('.searchWrap').addClass('formOpen');
                    $('#content').find('.searchWrap').removeClass('hideForm');

                    if ($('.js_offersMenuMobile').is(':visible')) {
                        $('.js_offersMenuMobile').slideUp(function () {
                            $('.js_mobileOffersTrigger').removeClass('active');
                            $('.js_triggerSearch').addClass('active');
                            $('#content').find('.searchWrap').stop(true, true).slideDown();
                            checkCashOrMonthly();
                        });
                    } else {
                        $('.flyoutWrap').slideUp(function () {
                            $('.flyout').removeClass('alive');
                            $('.js_triggerSearch').addClass('active');
                            $('#content').find('.searchWrap').stop(true, true).slideDown();
                            checkCashOrMonthly();
                        });
                    }

                    search_trigger.removeClass('loading');
                }
            });
        }
    });
}

$(document).ready(function () {
    'use strict';

    /* ------------------------------ */
    /* MTC Mobile Menu  */
    /* ------------------------------ */

    $.mtcMobileMenu({
        menuPosition: 'top',
        buttonAppend: null,
        nestedAccordion: true,
        nestedWrap: 'div.sub',
        clone: true,
        breakpoint: 1024,
        moveSite: false,
        enableDrag: false
    });

    $('.js_triggerSearch').on('click', function(e) {
        e.preventDefault();

        // this is added / removed within showHideSearchContents()
        if ($(this).hasClass('loading')) {
            return false;
        }

        if ($('.hasFranchise').length > 0) {
            $('.hasFranchise').slideUp(function () {

                $('.hasFranchise').attr('style', '');
                $('.hasFranchise').find('.open').removeClass('open');
                $('.hasFranchise').find('.column ul').attr('style', '');
                $('.hasFranchise').find('.sub').attr('style', '');

                showHideSearchContents();
            });
        } else {
            showHideSearchContents();
        }
    });
});